<template>
  <div class="detail">
    <div
      v-loading.fullscreen.lock="fullscreenLoading"
      class="orderdetails"
      element-loading-text="拼命加载中"
      element-loading-spinner="el-icon-loading"
      element-loading-background="rgba(0, 0, 0, 0.8)"
    >
      <h4 class="publish-h5">面试者详情表</h4>
      <div class="tip">
        公司承诺：以下信息仅用于本公司应聘登记，本公司严格遵守保密义务，不作他用。
      </div>
      <h4 class="publish-h4">
        <div class="addcar-h4-span">应聘信息</div>
      </h4>

      <el-form
        ref="formInline"
        :inline="true"
        :model="formInline"
        :rules="rules"
        class="demo-form-inline"
        style="position: relative"
      >
        <el-form-item
          label="获取招聘途径:"
          class="publishFinancing-item black"
          :label-width="formLabelWidth"
          prop="period"
        >
          <span>{{ firmData.recruitmentWay }}</span>
        </el-form-item>

        <el-form-item
          v-if="firmData.recruitmentWay == '网络'"
          label="网络渠道:"
          class="publishFinancing-item black"
          :label-width="formLabelWidth"
        >
          <span>{{ firmData.networkRecruitment }}</span>
        </el-form-item>

        <el-form-item
          label="应聘职位:"
          class="publishFinancing-item black"
          :label-width="formLabelWidth"
          prop="period"
        >
          <span>{{ firmData.positionApplied }}</span>
        </el-form-item>

        <div>
          <el-form-item
            label="期望薪资(税前):"
            class="publishFinancing-item black"
            :label-width="formLabelWidth"
            prop="period"
          >
            <span>{{ firmData.expectedSalary }}</span>
          </el-form-item>

          <el-form-item
            label="是否离职:"
            class="publishFinancing-item black"
            :label-width="formLabelWidth"
            prop="period"
          >
            <span>{{ firmData.inWork }}</span>
          </el-form-item>

          <el-form-item
            label="求职动机:"
            class="publishFinancing-item black"
            :label-width="formLabelWidth"
            prop="period"
          >
            <span>{{ firmData.jobSearchMotivation }}</span>
          </el-form-item>

          <el-form-item
            label="预计报到时间:"
            class="publishFinancing-item black"
            :label-width="formLabelWidth"
            prop="startTime"
          >
            <span>{{ firmData.expectedWorkTime }}</span>
          </el-form-item>
          <el-form-item
            label="备注:"
            class="publishFinancing-item black"
            prop="context"
          >
            <span class="red">{{ firmData.context || "" }}</span>
          </el-form-item>
        </div>
      </el-form>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">基本信息</div>
      </h4>

      <el-form :inline="true" class="normal-form-inline">
        <el-form-item label="姓名:" class="publishFinancing-orderinfo black">
          <span>{{ firmData.name }}</span>
        </el-form-item>

        <el-form-item label="性别:" class="publishFinancing-orderinfo black">
          <span>{{ firmData.gender }}</span>
        </el-form-item>

        <el-form-item
          label="身份证号:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.idCard }}</span>
        </el-form-item>

        <el-form-item
          label="出生年月:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.bornTime }}</span>
        </el-form-item>

        <el-form-item label="民族:" class="publishFinancing-orderinfo black">
          <span>{{ firmData.national }}</span>
        </el-form-item>

        <el-form-item label="户籍地:" class="publishFinancing-orderinfo black">
          <span>{{ firmData.domicile }}</span>
        </el-form-item>

        <el-form-item
          label="身高/体重:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.height }}cm/{{ firmData.weight }}kg</span>
        </el-form-item>

        <el-form-item
          label="是否存在竞业限制:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.competitionRestrictions }}</span>
        </el-form-item>

        <el-form-item
          label="是否存在未解除的劳动关系:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.laborRelations }}</span>
        </el-form-item>

        <el-form-item
          label="联系电话:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.mobile }}</span>
        </el-form-item>

        <el-form-item
          label="紧急联系人/关系:"
          class="publishFinancing-orderinfo black"
        >
          <span
            >{{ firmData.emergencyMan }}/{{
              firmData.emergencyManRelationship
            }}</span
          >
        </el-form-item>

        <el-form-item
          label="紧急联系人电话:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.emergencyMobile }}</span>
        </el-form-item>

        <el-form-item
          label="上班出行方式:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.workWay }}</span>
        </el-form-item>

        <el-form-item
          label="上班花费的时间:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.workSpendTime }}分钟</span>
        </el-form-item>

        <el-form-item
          label="婚否/育否:"
          class="publishFinancing-orderinfo black"
          v-if="firmData.gender !== '女'"
        >
          <span>{{ firmData.married }}/{{ firmData.fertility }}</span>
        </el-form-item>
        <el-form-item
          label="婚否/育否/孕否:"
          class="publishFinancing-orderinfo black"
          v-else
        >
          <span
            >{{ firmData.married }}/{{ firmData.fertility
            }}{{ firmData.pregnant ? "/" + firmData.pregnant : "" }}</span
          >
        </el-form-item>

        <el-form-item
          label="是否与公司现有员工存在亲属或恋爱关系:"
          class="publishFinancing-orderinfo black"
        >
          <span v-if="firmData.existRelationship">
            {{ firmData.existRelationship.exist }}

            <span v-if="firmData.existRelationship.exist == '有'"
              >({{ firmData.existRelationship.name }},{{
                firmData.existRelationship.relationship
              }})</span
            >
          </span>
        </el-form-item>

        <el-form-item
          :label="formatJobCatLabel"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.ifJobCut }}</span>
        </el-form-item>
        <el-form-item
          label="您能否提供最近6个月的工资流水:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.providePayroll }}</span>
        </el-form-item>

        <el-form-item
          label="现居住地址:"
          class="publishFinancing-orderinfo black"
        >
          <span>{{ firmData.address }}</span>
        </el-form-item>
      </el-form>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">家庭情况</div>
      </h4>

      <el-table
        class="dytable"
        :data="firmData.familyInformation"
        :header-cell-style="{ background: '#304156', color: '#fff' }"
        :cell-style="{ color: '#000' }"
      >
        <el-table-column prop="relationship" label="关系" />

        <el-table-column prop="name" label="姓名" />

        <el-table-column prop="age" label="年龄" />

        <el-table-column prop="workPlace" label="工作单位" />

        <el-table-column prop="jobTitle" label="职务" />
      </el-table>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">教育背景</div>
      </h4>

      <el-table
        class="dytable"
        :data="firmData.educationBackground"
        :header-cell-style="{ background: '#304156', color: '#fff' }"
        :cell-style="{ color: '#000' }"
      >
        <el-table-column prop="schoolName" label="学校名称" />

        <el-table-column prop="unification" label="是否统招" />

        <el-table-column prop="profession" label="专业" />

        <el-table-column prop="graduationTime" label="毕业时间" />

        <el-table-column prop="education" label="学历" />
        <el-table-column prop="highExamScore" label="高考分数" />
      </el-table>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">培训经历</div>
      </h4>

      <el-table
        class="dytable"
        :data="firmData.trainingExperience"
        :header-cell-style="{ background: '#304156', color: '#fff' }"
        :cell-style="{ color: '#000' }"
      >
        <el-table-column
          prop="endTime"
          label="培训时间"
          :formatter="getDatesq"
        />

        <el-table-column prop="project" label="培训项目" />

        <el-table-column prop="certificate" label="获得职称/证书" />
      </el-table>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">工作经历</div>
      </h4>

      <el-table
        class="dytable"
        :data="firmData.workExperience"
        :header-cell-style="{ background: '#304156', color: '#fff' }"
        :cell-style="{ color: '#000' }"
      >
        <el-table-column
          prop="endTime"
          label="起止时间"
          :formatter="getDatesq"
        />

        <el-table-column prop="company" label="公司名称" />

        <el-table-column
          prop="companyNumber"
          label="公司规模"
          :formatter="getCompanyNumber"
        />

        <el-table-column prop="position" label="职位" />

        <el-table-column prop="salary" label="月薪(元/月)" />

        <el-table-column prop="reasonForLeaving" label="离职原因" />

        <el-table-column prop="proveMan" label="证明人" />

        <el-table-column prop="proveMobile" label="联系方式" />
      </el-table>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">相关问题</div>
      </h4>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          1.请谈谈最近一份工作（或跟应聘岗位相关的工作）经历的工作内容及模式？:
        </div>

        <div class="textarea" v-html="firmData.jobContentAndModel"></div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          2.您拥有哪些优质的行业资源？请列举至少三个：
        </div>

        <div class="textarea" v-html="firmData.industryResources"></div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          3.请谈谈您对所应聘岗位的工作内容的认识和感受。您认为应聘本岗位应具备哪些能力，您是否具备：
        </div>

        <div class="textarea" v-html="firmData.workKnowledgeAndFeelings"></div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          4.您的自我评价（优点与缺点分析）：
        </div>

        <div class="textarea" v-html="firmData.selfEvaluation"></div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          5.您愿意从事的职业及您1~3年内的职业发展规划：
        </div>

        <div class="textarea" v-html="firmData.careerDevelopmentPlanning"></div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          6.您觉得有必要告知我们的其它信息：
        </div>

        <div class="textarea" v-html="firmData.otherInformation"></div>
      </div>

      <h4 class="publish-h4">
        <div class="addcar-h4-span">本人承诺</div>
      </h4>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          1.本人承诺：“本表中所填写信息全部真实、完整、有效。若因不真实、不完整引起的一切不利后果均由本人承担。”
        </div>
      </div>

      <div class="firm-recommend font14">
        <div class="firm-recommend-title">
          2.本人同意公司可根据需要对本人工作经历进行背景调查。
        </div>
      </div>

      <div class="firm-recommend font14" style="float: right">
        <div class="firm-recommend-title">
          <span style="margin-right: 10px">承诺人:__________</span>

          <span>日期:_____年_____月_____日</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getInterviewInfo } from "../util/api/job";

export default {
  name: "InterviewDetail",
  data() {
    return {
      formLabelWidth: "120px",
      fullscreenLoading: false,
      firmData: {},
      formInline: {},
      rules: {},
    };
  },
  computed: {
    formatJobCatLabel() {
      const judgeDate = new Date("2025-9-3 00:00:00").getTime();
      const judge = new Date(this.firmData.createTime).getTime() > judgeDate;
      return judge ? "是否经历过劳动纠纷:" : "是否经历过裁员:";
    },
  },
  created() {
    if (!this.$route.query.id) {
      this.$router.replace({ path: "/job" });
      return;
    }
    getInterviewInfo({ id: this.$route.query.id }).then((res) => {
      this.firmData = res.data;
      if (
        !this.firmData.trainingExperience ||
        this.firmData.trainingExperience.length <= 0
      ) {
        this.firmData.trainingExperience = [{}];
      }
      if (
        !this.firmData.familyInformation ||
        this.firmData.familyInformation.length <= 0
      ) {
        this.firmData.familyInformation = [{}, {}, {}];
      }
    });
  },
  methods: {
    getDatesq(row) {
      if (row.startTime && row.endTime) {
        return row.startTime + "至" + row.endTime;
      }
      return "";
    },
    getCompanyNumber(row, column, data) {
      return data ? data + "人" : "--";
    },
  },
};
</script>

<style>
.tip {
  margin: 20px 0 10px;
  font-weight: bold;
}
.detail {
  text-align: left !important;
  background-color: #fff;
}
.detail .el-table tr {
  height: 34px !important;
}

.textarea {
  vertical-align: bottom;
  font-size: 14px;
}

.orderdetails {
  padding: 0 40px;
}

.orderdetails-top {
  overflow: hidden;
}

.text-item-serial {
  margin: 20px 10px;
  display: block;
  width: 20%;
}

.text-item-key {
  float: left;
  font-weight: bold;
  color: #000;
}

.text-item-value {
  float: left;
}

.publishFinancing-item {
  width: 30%;
}

.publishFinancing-searchitem {
  width: 15%;
}

.publishFinancing-date {
  width: 45%;
}

.pubulishbid-textarea {
  width: 60%;
  display: block !important;
}

.detail .el-form-item__content {
  width: 70%;
  line-height: 25px;
  text-align: left !important;
}

.el-timeline {
  margin-top: 30px !important;
}

.userdetails-backbtn {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 45px;
  margin-top: 47px;
}

.userdetails-backbtn-bg {
  width: 190px;
  height: 45px;
}

.orderdetails-logistics {
  width: 100%;
  height: 50px;
  line-height: 50px;
  background-color: rgb(236, 245, 255);
  margin: 10px 0;
}

.orderdetails-top-address {
  width: 100%;
  padding: 10px;
  float: left;
  border-top: 1px solid #000;
}

.orderdetails-top-btn {
  float: right;
  margin-bottom: 10px;
}

.orderdetails .el-dialog {
  width: 80%;
}

.addcar-card-item {
  width: 100%;
  overflow: hidden;
  padding: 10px 0;
}

.publish-h4 {
  border-bottom: 1px solid #000;
}
.publish-h5 {
  text-align: center;
  margin: 10px 0;
}

.addcar-h4-img {
  display: inline-block;
  width: 50px;
  height: 50px;
}

.addcar-h4-span {
  display: inline-block;
  height: 40px;
  line-height: 40px;
  vertical-align: top;
}

.addcar-card {
  width: 100%;
}

.addcar-card .el-card__body {
  padding: 0 20px;
  max-height: 200px;
  overflow-y: scroll;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}

.clearfix:after {
  clear: both;
}

.addcar-backbtn {
  display: flex;
  justify-content: center;
  width: 100%;
  height: 45px;
  margin-top: 47px;
}

.addcar-backbtn-bg {
  height: 45px;
}

.firm-recommend {
  margin: 10px 0 20px 0;
}

.firm-recommend-title {
  margin: 10px 0;
}

.publishFinancing-orderinfo {
  width: 30%;
  display: inline-block;
}

.publishFinancing-orderitem {
  width: 30%;
  display: inline-block;
}

.publishFinancing-orderitem-span {
  text-align: center;
}

.lishide .el-upload--picture-card {
  display: none;
}

.table-tooltips {
  width: 100%;
  height: auto;
  white-space: nowrap !important;
  overflow: hidden;
  text-overflow: ellipsis;
}

.table-tooltips-content {
  width: 100%;
  height: auto;
}

.el-textarea img {
  display: inherit;
}

.audit-imgicon {
  position: absolute;
  right: 50px;
  bottom: -50px;
  width: 130px;
  height: 130px;
}

.detail .el-form--inline .el-form-item {
  white-space: nowrap;
}

.detail .el-form-item {
  margin-bottom: 10px !important;
}

.detail .el-form-item__label {
  color: #000 !important;
  text-align: left !important;
  line-height: 25px;
  font-weight: bold;
}

.el-input__inner {
  color: #000;
}

.normal-form-inline .el-form-item__content {
  line-height: 25px !important;
}
.red {
  color: red;
}
</style>
